import Vue from 'vue';
import { createActionHelpers } from 'vuex-loading';
import Service from './service';
import OpService from '../operation/service';
import { updateOperationNotary } from '../notary/store';

const { startLoading, endLoading } = createActionHelpers({
  moduleName: 'loading',
});

export const CLEAR_MODULE = 'CLEAR_MODULE';
export const UPDATE_ERROR = 'UPDATE_ERROR';
export const UPDATE_LOADED = 'UPDATE_LOADED';
export const UPDATE_NOTARY_DATA = 'UPDATE_NOTARY_DATA';
export const FORMAT_MODEL = 'FORMAT_MODEL';
export const saveNotaryAction = 'saveNotaryAction';
export const initModuleAction = 'initModuleAction';
export const updateStatusCanceladaAction = 'updateStatusCanceladaAction';

export default {
  namespaced: true,
  state: {
    error: '',
    loading: true,
    notaryData: {},
  },
  mutations: {
    [CLEAR_MODULE](state) {
      Vue.set(state, 'types', {});
      Vue.set(state, 'loading', true);
      Vue.set(state, 'error', '');
      Vue.set(state, 'notaryData', {});
    },
    [UPDATE_ERROR](state, payload) {
      Vue.set(state, 'error', payload);
    },
    [UPDATE_LOADED](state, payload) {
      Vue.set(state, 'loading', payload);
    },
    [FORMAT_MODEL](state, payload) {
      Vue.set(state, 'notaryData', payload);
    },
    [UPDATE_NOTARY_DATA](state, payload) {
      Vue.set(state, 'notaryData', payload);
    },
  },
  actions: {
    [initModuleAction]({ commit, rootGetters, dispatch }, payload) {
      startLoading(dispatch, 'init cancelacion');
      commit(UPDATE_LOADED, true);
      commit(CLEAR_MODULE);
      if (payload) {
        Service.getData(payload)
          .then((res) => {
            commit(FORMAT_MODEL, res);
            commit(UPDATE_LOADED, false);
          });
      }
      endLoading(dispatch, 'init cancelacion');
    },

    [updateStatusCanceladaAction]({ commit, rootGetters, dispatch }, payload) {
      const cancelada = rootGetters['taxonomy/searchTaxonomyValue']({ vid: 'status', text: 'Cancelada' });
      OpService.updateOperation({ id: payload, state: cancelada });
    },
    [updateOperationNotary]({ commit, dispatch }, payload) {
      startLoading(dispatch, 'update cancelacion');
      return Service.updateOperationNotary(payload)
        .then(() => {
          Service.updateDatesAssigments(payload)
            .then(() => endLoading(dispatch, 'update cancelacion'));
        }).catch((error) => {
          if (error && error.response) {
            dispatch('updateErrorOverlay', error, { root: true });
            endLoading(dispatch, 'update cancelacion');
          }
        });
    },
  },
  getters: {
    loading: state => state.loading,
    notaryData: state => state.notaryData,
  },
};



// WEBPACK FOOTER //
// ./src/features/cancelacion/store.js